import { renderDate } from "@intrasync/utils";
import { ScheduleGridBodyCellProps } from "components/ScheduleGrid/ScheduleGrid.Types";

interface ProductionScheduleLeftBodyCellProps
  extends ScheduleGridBodyCellProps {
  scheduleDate: string;
  rowCount: number;
  rowData: { entities: { moldNumber: string }[] };
}

const ProductionScheduleLeftBodyCell = (
  props: ProductionScheduleLeftBodyCellProps
) => {
  const {
    rowCount,
    scheduleDate,
  } = props;
  const backgroundColor = props.rowIndex % 2 === 0 ? "#f0f0f0" : "#e0e0e0";

  return (
    <div
      style={{
        ...props.style,
        ...props.styles,
        borderLeft: "1px solid #eee",
        borderRight: "1px solid #eee",
        borderTop: "1px solid #eee",
        borderBottom: "2px solid black",
        backgroundColor: backgroundColor,
        height: ((props?.style?.height as number) || 50) - 3,
      }}
    >
      <b>{renderDate(scheduleDate)}</b>
      {rowCount >= 1 && (
        <>
          <b>
            {rowCount} {rowCount === 1 ? "piece" : "pieces"}
          </b>
        </>
      )}
    </div>
  );
};

export default ProductionScheduleLeftBodyCell;
